import ScopedBlogCreate from '@/components/blog/scoped-blog-create';
import { ROUTES } from '@/config/routes';
import { adminSidebar } from '@/config/sidebarConfig';

export default function AdminBlogCreate() {
  return (
    <ScopedBlogCreate sidebarConfig={adminSidebar} listRoute={ROUTES.ADMIN_BLOG} showCategoryManager showFeatured />
  );
}
